import { useCallback } from 'react';
import useWfProductRepo, {
  WfProductDetailsParams,
  WfProductParams,
} from '../repository/WfProductRepo';
import { useWfProductStore } from '../stores/WfProductStore';
import { WfProduct } from '../models/WfProduct';

function useWfProductService() {
  const { getProductsRequest, getProductDetailsRequest } = useWfProductRepo();
  const { setProducts, setProductDetails } = useWfProductStore();

  const sortProductsByProductNumber = (products: WfProduct[]): WfProduct[] => {
    return [...products].sort((a, b) => a.productNumber.localeCompare(b.productNumber));
  };

  const fetchProducts = useCallback(
    async (params: WfProductParams) => {
      const products = await getProductsRequest(params);
      const sortedProducts = sortProductsByProductNumber(products);
      setProducts(sortedProducts);
      return sortedProducts;
    },
    [getProductsRequest, setProducts]
  );

  const fetchProductDetails = useCallback(
    async (params: WfProductDetailsParams) => {
      const productDetails = await getProductDetailsRequest(params);

      setProductDetails(productDetails);
    },
    [getProductDetailsRequest, setProductDetails]
  );

  return {
    fetchProducts,
    fetchProductDetails,
  };
}

export default useWfProductService;
